/**
 * Dog Breeds Data
 * Generated from CSV: Dog breeds - Sheet2.csv
 * Total breeds: 596
 */

const BREEDS_DATA = [
  {
    "value": "mixed",
    "label_en": "Mixed",
    "label_nl": "Kruising",
    "avg_weight_male": 18.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "dont_know",
    "label_en": "I don't know",
    "label_nl": "Weet ik niet",
    "avg_weight_male": 18.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "affenpinscher",
    "label_en": "Affenpinscher",
    "label_nl": "Affenpinscher",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "afghan_hound",
    "label_en": "Afghan Hound",
    "label_nl": "Afghaanse windhond",
    "avg_weight_male": 27.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "africanis",
    "label_en": "Africanis",
    "label_nl": "Africanis",
    "avg_weight_male": 24.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "aidi",
    "label_en": "Aidi",
    "label_nl": "Atlasberghond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "airedale_terrier",
    "label_en": "Airedale Terrier",
    "label_nl": "Airedale terriër",
    "avg_weight_male": 23.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "akbash",
    "label_en": "Akbash",
    "label_nl": "Akbash",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "akita",
    "label_en": "Akita",
    "label_nl": "Akita",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "aksaray_malaklisi",
    "label_en": "Aksaray Malaklisi",
    "label_nl": "Aksaray malaklisi",
    "avg_weight_male": 65.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "alano_espanol",
    "label_en": "Alano Español",
    "label_nl": "Spaanse alano",
    "avg_weight_male": 40.0,
    "avg_weight_female": 34.0
  },
  {
    "value": "alapaha_blue_blood_bulldog",
    "label_en": "Alapaha Blue Blood Bulldog",
    "label_nl": "Alapaha blue blood bulldog",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "alaskan_husky",
    "label_en": "Alaskan Husky",
    "label_nl": "Alaskische husky",
    "avg_weight_male": 26.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "alaskan_klee_kai",
    "label_en": "Alaskan Klee Kai",
    "label_nl": "Alaskan klee kai",
    "avg_weight_male": 11.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "alaskan_malamute",
    "label_en": "Alaskan Malamute",
    "label_nl": "Alaskan malamute",
    "avg_weight_male": 38.0,
    "avg_weight_female": 34.0
  },
  {
    "value": "alopekis",
    "label_en": "Alopekis",
    "label_nl": "Alopekis",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "alpine_dachsbracke",
    "label_en": "Alpine Dachsbracke",
    "label_nl": "Alpenländische dachsbrak",
    "avg_weight_male": 18.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "american_bulldog",
    "label_en": "American Bulldog",
    "label_nl": "Amerikaanse bulldog",
    "avg_weight_male": 50.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "american_bully",
    "label_en": "American Bully",
    "label_nl": "American bully",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "american_cocker_spaniel",
    "label_en": "American Cocker Spaniel",
    "label_nl": "Amerikaanse cockerspaniël",
    "avg_weight_male": 14.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "american_english_coonhound",
    "label_en": "American English Coonhound",
    "label_nl": "American English coonhound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "american_eskimo_dog",
    "label_en": "American Eskimo Dog",
    "label_nl": "Amerikaanse eskimohond",
    "avg_weight_male": 14.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "american_foxhound",
    "label_en": "American Foxhound",
    "label_nl": "Amerikaanse foxhound",
    "avg_weight_male": 31.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "american_hairless_terrier",
    "label_en": "American Hairless Terrier",
    "label_nl": "Amerikaanse haarloze terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "american_leopard_hound",
    "label_en": "American Leopard Hound",
    "label_nl": "American leopard hound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "american_pit_bull_terrier",
    "label_en": "American Pit Bull Terrier",
    "label_nl": "American pitbull terriër",
    "avg_weight_male": 30.0,
    "avg_weight_female": 24.0
  },
  {
    "value": "american_staffordshire_terrier",
    "label_en": "American Staffordshire Terrier",
    "label_nl": "American staffordshire terriër",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "american_water_spaniel",
    "label_en": "American Water Spaniel",
    "label_nl": "Amerikaanse waterspaniël",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "andalusian_terrier",
    "label_en": "Andalusian Terrier",
    "label_nl": "Andalusische terriër",
    "avg_weight_male": 9.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "anglo_francais_de_petite_venerie",
    "label_en": "Anglo-Français de Petite Vénerie",
    "label_nl": "Anglo Franse petite vénerie",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "appenzeller_sennenhund",
    "label_en": "Appenzeller Sennenhund",
    "label_nl": "Appenzeller sennenhond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "argentine_pila",
    "label_en": "Argentine Pila",
    "label_nl": "Argentijnse pila",
    "avg_weight_male": 9.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "ariege_pointer",
    "label_en": "Ariège Pointer",
    "label_nl": "Ariège pointer",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "ariegeois",
    "label_en": "Ariégeois",
    "label_nl": "Ariégeois",
    "avg_weight_male": 28.0,
    "avg_weight_female": 24.0
  },
  {
    "value": "armant",
    "label_en": "Armant",
    "label_nl": "Armant",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "armenian_gampr",
    "label_en": "Armenian Gampr",
    "label_nl": "Armeense gampr",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "artois_hound",
    "label_en": "Artois Hound",
    "label_nl": "Artois hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 26.0
  },
  {
    "value": "aussiedoodle",
    "label_en": "Aussiedoodle",
    "label_nl": "Aussiedoodle",
    "avg_weight_male": 26.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "australian_cattle_dog",
    "label_en": "Australian Cattle Dog",
    "label_nl": "Australische veedrijvershond",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "australian_kelpie",
    "label_en": "Australian Kelpie",
    "label_nl": "Australische kelpie",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "australian_shepherd",
    "label_en": "Australian Shepherd",
    "label_nl": "Australische herder",
    "avg_weight_male": 28.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "australian_silky_terrier",
    "label_en": "Australian Silky Terrier",
    "label_nl": "Australische silky terriër",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "australian_stumpy_tail_cattle_dog",
    "label_en": "Australian Stumpy Tail Cattle Dog",
    "label_nl": "Australische stumpy tail cattle dog",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "australian_terrier",
    "label_en": "Australian Terrier",
    "label_nl": "Australische terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "austrian_black_and_tan_hound",
    "label_en": "Austrian Black and Tan Hound",
    "label_nl": "Oostenrijkse zwartbruine brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "austrian_pinscher",
    "label_en": "Austrian Pinscher",
    "label_nl": "Oostenrijkse pinscher",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "azawakh",
    "label_en": "Azawakh",
    "label_nl": "Azawakh",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "bakharwal",
    "label_en": "Bakharwal",
    "label_nl": "Bakharwal",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "banjara_hound",
    "label_en": "Banjara Hound",
    "label_nl": "Banjara hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "bankhar_dog",
    "label_en": "Bankhar Dog",
    "label_nl": "Bankhar hond",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "barak_hound",
    "label_en": "Barak hound",
    "label_nl": "Barak hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "barbado_da_terceira",
    "label_en": "Barbado da Terceira",
    "label_nl": "Barbado da Terceira",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "barbet",
    "label_en": "Barbet",
    "label_nl": "Barbet",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "basenji",
    "label_en": "Basenji",
    "label_nl": "Basenji",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "basque_shepherd_dog",
    "label_en": "Basque Shepherd Dog",
    "label_nl": "Baskische herdershond",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "basset_artesien_normand",
    "label_en": "Basset Artésien Normand",
    "label_nl": "Basset artésien normand",
    "avg_weight_male": 24.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "basset_bleu_de_gascogne",
    "label_en": "Basset Bleu de Gascogne",
    "label_nl": "Basset bleu de gascogne",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "basset_fauve_de_bretagne",
    "label_en": "Basset Fauve de Bretagne",
    "label_nl": "Basset fauve de bretagne",
    "avg_weight_male": 18.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "basset_hound",
    "label_en": "Basset Hound",
    "label_nl": "Basset",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "bavarian_mountain_hound",
    "label_en": "Bavarian Mountain Hound",
    "label_nl": "Beierse bergzweethond",
    "avg_weight_male": 27.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "beagador",
    "label_en": "Beagador",
    "label_nl": "Beagador",
    "avg_weight_male": 24.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "beagle",
    "label_en": "Beagle",
    "label_nl": "Beagle",
    "avg_weight_male": 13.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "beagle_harrier",
    "label_en": "Beagle-Harrier",
    "label_nl": "Beagle harrier",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "bearded_collie",
    "label_en": "Bearded Collie",
    "label_nl": "Bearded collie",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "beauceron",
    "label_en": "Beauceron",
    "label_nl": "Beauceron",
    "avg_weight_male": 40.0,
    "avg_weight_female": 34.0
  },
  {
    "value": "bedlington_terrier",
    "label_en": "Bedlington Terrier",
    "label_nl": "Bedlington terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "belgian_shepherd",
    "label_en": "Belgian Shepherd",
    "label_nl": "Belgische herder",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "bergamasco_shepherd",
    "label_en": "Bergamasco Shepherd",
    "label_nl": "Bergamasco herdershond",
    "avg_weight_male": 38.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "berger_picard",
    "label_en": "Berger Picard",
    "label_nl": "Picardische herder",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "bernedoodle",
    "label_en": "Bernedoodle",
    "label_nl": "Bernedoodle",
    "avg_weight_male": 38.0,
    "avg_weight_female": 34.0
  },
  {
    "value": "bernese_mountain_dog",
    "label_en": "Bernese Mountain Dog",
    "label_nl": "Berner sennenhond",
    "avg_weight_male": 50.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "bichon_frise",
    "label_en": "Bichon Frisé",
    "label_nl": "Bichon frisé",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "biewer_terrier",
    "label_en": "Biewer Terrier",
    "label_nl": "Biewer terriër",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "billy",
    "label_en": "Billy",
    "label_nl": "Billy",
    "avg_weight_male": 34.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "black_and_tan_coonhound",
    "label_en": "Black and Tan Coonhound",
    "label_nl": "Black and tan coonhound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "black_mouth_cur",
    "label_en": "Black Mouth Cur",
    "label_nl": "Black mouth cur",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "black_norwegian_elkhound",
    "label_en": "Black Norwegian Elkhound",
    "label_nl": "Zwarte Noorse elandhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "black_russian_terrier",
    "label_en": "Black Russian Terrier",
    "label_nl": "Zwarte Russische terriër",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "bloodhound",
    "label_en": "Bloodhound",
    "label_nl": "Bloedhond",
    "avg_weight_male": 50.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "blue_lacy",
    "label_en": "Blue Lacy",
    "label_nl": "Blue lacy",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "blue_picardy_spaniel",
    "label_en": "Blue Picardy Spaniel",
    "label_nl": "Picardische spaniël",
    "avg_weight_male": 24.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "bluetick_coonhound",
    "label_en": "Bluetick Coonhound",
    "label_nl": "Bluetick coonhound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "boerboel",
    "label_en": "Boerboel",
    "label_nl": "Boerboel",
    "avg_weight_male": 75.0,
    "avg_weight_female": 60.0
  },
  {
    "value": "bohemian_shepherd",
    "label_en": "Bohemian Shepherd",
    "label_nl": "Boheemse herder",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "bohemian_spotted_dog",
    "label_en": "Bohemian Spotted Dog",
    "label_nl": "Boheemse gevlekte hond",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "bolognese",
    "label_en": "Bolognese",
    "label_nl": "Bolognezer",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "border_collie",
    "label_en": "Border Collie",
    "label_nl": "Border Collie",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "border_terrier",
    "label_en": "Border Terrier",
    "label_nl": "Border terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "bordoodle",
    "label_en": "Bordoodle",
    "label_nl": "Bordoodle",
    "avg_weight_male": 22.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "borzoi",
    "label_en": "Borzoi",
    "label_nl": "Barzoi",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "boston_terrier",
    "label_en": "Boston Terrier",
    "label_nl": "Boston terriër",
    "avg_weight_male": 11.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "bouvier_des_ardennes",
    "label_en": "Bouvier des Ardennes",
    "label_nl": "Bouvier des Ardennes",
    "avg_weight_male": 28.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "bouvier_des_flandres",
    "label_en": "Bouvier des Flandres",
    "label_nl": "Bouvier",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "boxador",
    "label_en": "Boxador",
    "label_nl": "Boxador",
    "avg_weight_male": 32.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "boxer",
    "label_en": "Boxer",
    "label_nl": "Boxer",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "boykin_spaniel",
    "label_en": "Boykin Spaniel",
    "label_nl": "Boykin spaniël",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "bracco_italiano",
    "label_en": "Bracco Italiano",
    "label_nl": "Bracco italiano",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "braque_d_auvergne",
    "label_en": "Braque d'Auvergne",
    "label_nl": "Braque d'Auvergne",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "braque_du_bourbonnais",
    "label_en": "Braque du Bourbonnais",
    "label_nl": "Braque du Bourbonnais",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "braque_francais",
    "label_en": "Braque Français",
    "label_nl": "Braque français",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "braque_saint_germain",
    "label_en": "Braque Saint-Germain",
    "label_nl": "Braque Saint Germain",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "brazilian_terrier",
    "label_en": "Brazilian Terrier",
    "label_nl": "Braziliaanse terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "briard",
    "label_en": "Briard",
    "label_nl": "Briard",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "briquet_de_provence",
    "label_en": "Briquet de Provence",
    "label_nl": "Briquet de provence",
    "avg_weight_male": 28.0,
    "avg_weight_female": 24.0
  },
  {
    "value": "briquet_griffon_vendeen",
    "label_en": "Briquet Griffon Vendéen",
    "label_nl": "Briquet griffon vendéen",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "brittany",
    "label_en": "Brittany",
    "label_nl": "Bretonse spaniël",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "broholmer",
    "label_en": "Broholmer",
    "label_nl": "Broholmer",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "bruno_jura_hound",
    "label_en": "Bruno Jura Hound",
    "label_nl": "Bruno Jura hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "bucovina_shepherd_dog",
    "label_en": "Bucovina Shepherd Dog",
    "label_nl": "Bucovina herdershond",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "bulgarian_hound",
    "label_en": "Bulgarian Hound",
    "label_nl": "Bulgaarse brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "bulgarian_scenthound",
    "label_en": "Bulgarian Scenthound",
    "label_nl": "Bulgaarse zweethond",
    "avg_weight_male": 28.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "bull_arab",
    "label_en": "Bull Arab",
    "label_nl": "Bull arab",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "bull_terrier",
    "label_en": "Bull Terrier",
    "label_nl": "Bull terriër",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "bulldog",
    "label_en": "Bulldog",
    "label_nl": "Engelse bulldog",
    "avg_weight_male": 26.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "bullmastiff",
    "label_en": "Bullmastiff",
    "label_nl": "Bullmastiff",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "bully_kutta",
    "label_en": "Bully Kutta",
    "label_nl": "Bully kutta",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "burgos_pointer",
    "label_en": "Burgos Pointer",
    "label_nl": "Burgos pointer",
    "avg_weight_male": 32.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "bac_ha",
    "label_en": "Bắc Hà",
    "label_nl": "Bắc Hà",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "ca_de_bou",
    "label_en": "Ca de Bou",
    "label_nl": "Ca de bou",
    "avg_weight_male": 38.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "ca_me_mallorqui",
    "label_en": "Ca Mè Mallorquí",
    "label_nl": "Ca mè mallorquí",
    "avg_weight_male": 38.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "ca_rater_mallorqui",
    "label_en": "Ca Rater Mallorquí",
    "label_nl": "Ca rater mallorquí",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "cairn_terrier",
    "label_en": "Cairn Terrier",
    "label_nl": "Cairn terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "calupoh",
    "label_en": "Calupoh",
    "label_nl": "Calupoh",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "campeiro_bulldog",
    "label_en": "Campeiro Bulldog",
    "label_nl": "Campeiro bulldog",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "can_de_chira",
    "label_en": "Can de Chira",
    "label_nl": "Can de chira",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "can_de_palleiro",
    "label_en": "Can de Palleiro",
    "label_nl": "Can de palleiro",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "canaan_dog",
    "label_en": "Canaan Dog",
    "label_nl": "Kanaänhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "canadian_eskimo_dog",
    "label_en": "Canadian Eskimo Dog",
    "label_nl": "Canadese eskimohond",
    "avg_weight_male": 36.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "cane_corso",
    "label_en": "Cane Corso",
    "label_nl": "Cane corso",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "cane_di_oropa",
    "label_en": "Cane di Oropa",
    "label_nl": "Cane di oropa",
    "avg_weight_male": 45.0,
    "avg_weight_female": 38.0
  },
  {
    "value": "cane_paratore",
    "label_en": "Cane Paratore",
    "label_nl": "Cane paratore",
    "avg_weight_male": 45.0,
    "avg_weight_female": 38.0
  },
  {
    "value": "cantabrian_water_dog",
    "label_en": "Cantabrian Water Dog",
    "label_nl": "Cantabrische waterhond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "cardigan_welsh_corgi",
    "label_en": "Cardigan Welsh Corgi",
    "label_nl": "Welsh corgi cardigan",
    "avg_weight_male": 17.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "carea_leones",
    "label_en": "Carea Leonés",
    "label_nl": "Carea leonés",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "carolina_dog",
    "label_en": "Carolina Dog",
    "label_nl": "Carolina hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "carpathian_shepherd_dog",
    "label_en": "Carpathian Shepherd Dog",
    "label_nl": "Karpatische herdershond",
    "avg_weight_male": 65.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "castro_laboreiro_dog",
    "label_en": "Castro Laboreiro Dog",
    "label_nl": "Castro laboreiro hond",
    "avg_weight_male": 45.0,
    "avg_weight_female": 38.0
  },
  {
    "value": "catahoula_leopard_dog",
    "label_en": "Catahoula Leopard Dog",
    "label_nl": "Catahoula leopard dog",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "catalan_sheepdog",
    "label_en": "Catalan Sheepdog",
    "label_nl": "Catalaanse herder",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "caucasian_shepherd_dog",
    "label_en": "Caucasian Shepherd Dog",
    "label_nl": "Kaukasische herder",
    "avg_weight_male": 70.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "cavachon",
    "label_en": "Cavachon",
    "label_nl": "Cavachon",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "cavalier_king_charles_spaniel",
    "label_en": "Cavalier King Charles Spaniel",
    "label_nl": "Cavalier king charles spaniël",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "cavapoo",
    "label_en": "Cavapoo",
    "label_nl": "Cavapoo",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "central_asian_shepherd_dog",
    "label_en": "Central Asian Shepherd Dog",
    "label_nl": "Centraal Aziatische herder",
    "avg_weight_male": 70.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "cesky_terrier",
    "label_en": "Cesky Terrier",
    "label_nl": "Cesky terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "chesapeake_bay_retriever",
    "label_en": "Chesapeake Bay Retriever",
    "label_nl": "Chesapeake bay retriever",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "chien_francais_blanc_et_noir",
    "label_en": "Chien Français Blanc et Noir",
    "label_nl": "Franse wit zwart hond",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "chien_francais_blanc_et_orange",
    "label_en": "Chien Français Blanc et Orange",
    "label_nl": "Franse wit oranje hond",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "chien_francais_tricolore",
    "label_en": "Chien Français Tricolore",
    "label_nl": "Franse driekleurige hond",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "chihuahua",
    "label_en": "Chihuahua",
    "label_nl": "Chihuahua",
    "avg_weight_male": 3.0,
    "avg_weight_female": 2.0
  },
  {
    "value": "chihuahua_terrier_mix",
    "label_en": "Chihuahua Terrier Mix",
    "label_nl": "Chihuahua Terriër mix",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "chilean_terrier",
    "label_en": "Chilean Terrier",
    "label_nl": "Chileense terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "chinese_crested_dog",
    "label_en": "Chinese Crested Dog",
    "label_nl": "Chinese naakthond",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "chinook",
    "label_en": "Chinook",
    "label_nl": "Chinook",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "chippiparai",
    "label_en": "Chippiparai",
    "label_nl": "Chippiparai",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "chiweenie",
    "label_en": "Chiweenie",
    "label_nl": "Chiweenie",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "chongqing",
    "label_en": "Chongqing",
    "label_nl": "Chongqing hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "chortai",
    "label_en": "Chortai",
    "label_nl": "Chortai",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "chow_chow",
    "label_en": "Chow Chow",
    "label_nl": "Chow chow",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "chug",
    "label_en": "Chug",
    "label_nl": "Chug",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "chukotka_sled_dog",
    "label_en": "Chukotka sled dog",
    "label_nl": "Chukotka sledehond",
    "avg_weight_male": 35.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "cimarron_uruguayo",
    "label_en": "Cimarrón Uruguayo",
    "label_nl": "Cimarrón Uruguayo",
    "avg_weight_male": 40.0,
    "avg_weight_female": 34.0
  },
  {
    "value": "cirneco_dell_etna",
    "label_en": "Cirneco dell'Etna",
    "label_nl": "Cirneco dell'Etna",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "clumber_spaniel",
    "label_en": "Clumber Spaniel",
    "label_nl": "Clumber spaniël",
    "avg_weight_male": 36.0,
    "avg_weight_female": 29.0
  },
  {
    "value": "cockapoo",
    "label_en": "Cockapoo",
    "label_nl": "Cockapoo",
    "avg_weight_male": 10.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "colombian_fino_hound",
    "label_en": "Colombian Fino Hound",
    "label_nl": "Colombiaanse fino hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "continental_bulldog",
    "label_en": "Continental bulldog",
    "label_nl": "Continental bulldog",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "corgidor",
    "label_en": "Corgidor",
    "label_nl": "Corgidor",
    "avg_weight_male": 22.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "corgipoo",
    "label_en": "Corgipoo",
    "label_nl": "Corgipoo",
    "avg_weight_male": 9.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "corsican_dog",
    "label_en": "Corsican Dog",
    "label_nl": "Corsicaanse hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "coton_de_tulear",
    "label_en": "Coton de Tulear",
    "label_nl": "Coton de tulear",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "cretan_hound",
    "label_en": "Cretan Hound",
    "label_nl": "Kretenzische hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "croatian_sheepdog",
    "label_en": "Croatian Sheepdog",
    "label_nl": "Kroatische herder",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "curly_coated_retriever",
    "label_en": "Curly-coated Retriever",
    "label_nl": "Curly coated retriever",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "czechoslovakian_wolfdog",
    "label_en": "Czechoslovakian Wolfdog",
    "label_nl": "Tsjechoslowaakse wolfhond",
    "avg_weight_male": 34.0,
    "avg_weight_female": 26.0
  },
  {
    "value": "cao_de_gado_transmontano",
    "label_en": "Cão de Gado Transmontano",
    "label_nl": "Cão de gado transmontano",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "dachshund",
    "label_en": "Dachshund",
    "label_nl": "Teckel",
    "avg_weight_male": 9.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "dachshund_chihuahua_mix",
    "label_en": "Dachshund Chihuahua Mix",
    "label_nl": "Teckel Chihuahua mix",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "dalmatian",
    "label_en": "Dalmatian",
    "label_nl": "Dalmatiër",
    "avg_weight_male": 27.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "dandie_dinmont_terrier",
    "label_en": "Dandie Dinmont Terrier",
    "label_nl": "Dandie dinmont terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "danish_spitz",
    "label_en": "Danish Spitz",
    "label_nl": "Deense spits",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "danish_swedish_farmdog",
    "label_en": "Danish–Swedish Farmdog",
    "label_nl": "Deense Zweedse boerderijhond",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "denmark_feist",
    "label_en": "Denmark Feist",
    "label_nl": "Denmark Feist",
    "avg_weight_male": 11.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "dikkulak",
    "label_en": "Dikkulak",
    "label_nl": "Dikkulak",
    "avg_weight_male": 35.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "dingo",
    "label_en": "Dingo",
    "label_nl": "Dingo",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "dobador",
    "label_en": "Dobador",
    "label_nl": "Dobador",
    "avg_weight_male": 36.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "dobermann",
    "label_en": "Dobermann",
    "label_nl": "Dobermann",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "dogo_argentino",
    "label_en": "Dogo Argentino",
    "label_nl": "Dogo Argentino",
    "avg_weight_male": 45.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "dogo_sardesco",
    "label_en": "Dogo Sardesco",
    "label_nl": "Dogo sardo",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "dogue_brasileiro",
    "label_en": "Dogue Brasileiro",
    "label_nl": "Dogue Brasileiro",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "dogue_de_bordeaux",
    "label_en": "Dogue de Bordeaux",
    "label_nl": "Bordeauxdog",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "donggyeongi",
    "label_en": "Donggyeongi",
    "label_nl": "Donggyeongi",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "doxiepoo",
    "label_en": "Doxiepoo",
    "label_nl": "Doxiepoo",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "drentse_patrijshond",
    "label_en": "Drentse Patrijshond",
    "label_nl": "Drentse Patrijshond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "drever",
    "label_en": "Drever",
    "label_nl": "Drever",
    "avg_weight_male": 16.0,
    "avg_weight_female": 13.0
  },
  {
    "value": "dunker",
    "label_en": "Dunker",
    "label_nl": "Dunker",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "dutch_shepherd",
    "label_en": "Dutch Shepherd",
    "label_nl": "Hollandse herder",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "dutch_smoushond",
    "label_en": "Dutch Smoushond",
    "label_nl": "Hollandse smoushond",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "east_european_shepherd",
    "label_en": "East European Shepherd",
    "label_nl": "Oost Europese herder",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "east_siberian_laika",
    "label_en": "East Siberian Laika",
    "label_nl": "Oost Siberische laika",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "ecuadorian_hairless_dog",
    "label_en": "Ecuadorian Hairless Dog",
    "label_nl": "Ecuadoraanse naakthond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "english_cocker_spaniel",
    "label_en": "English Cocker Spaniel",
    "label_nl": "Engelse cockerspaniël",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "english_foxhound",
    "label_en": "English Foxhound",
    "label_nl": "Engelse foxhound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "english_mastiff",
    "label_en": "English Mastiff",
    "label_nl": "Engelse mastiff",
    "avg_weight_male": 75.0,
    "avg_weight_female": 60.0
  },
  {
    "value": "english_setter",
    "label_en": "English Setter",
    "label_nl": "Engelse setter",
    "avg_weight_male": 30.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "english_shepherd",
    "label_en": "English Shepherd",
    "label_nl": "Engelse herder",
    "avg_weight_male": 30.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "english_springer_spaniel",
    "label_en": "English Springer Spaniel",
    "label_nl": "Engelse springerspaniël",
    "avg_weight_male": 23.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "english_toy_terrier_black_tan",
    "label_en": "English Toy Terrier (Black & Tan)",
    "label_nl": "Engelse toy terriër",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "entlebucher_mountain_dog",
    "label_en": "Entlebucher Mountain Dog",
    "label_nl": "Entlebucher sennenhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "erbi_txakur",
    "label_en": "Erbi Txakur",
    "label_nl": "Erbi Txakur",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "estonian_hound",
    "label_en": "Estonian Hound",
    "label_nl": "Estse hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "estrela_mountain_dog",
    "label_en": "Estrela Mountain Dog",
    "label_nl": "Estrela berghond",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "eurasier",
    "label_en": "Eurasier",
    "label_nl": "Eurasier",
    "avg_weight_male": 30.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "faroese_sheepdog",
    "label_en": "Faroese Sheepdog",
    "label_nl": "Faeröerse herdershond",
    "avg_weight_male": 24.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "field_spaniel",
    "label_en": "Field Spaniel",
    "label_nl": "Field spaniël",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "fila_brasileiro",
    "label_en": "Fila Brasileiro",
    "label_nl": "Fila Brasileiro",
    "avg_weight_male": 65.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "finnish_hound",
    "label_en": "Finnish Hound",
    "label_nl": "Finse brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "finnish_lapphund",
    "label_en": "Finnish Lapphund",
    "label_nl": "Finse lappenhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "finnish_spitz",
    "label_en": "Finnish Spitz",
    "label_nl": "Finse spits",
    "avg_weight_male": 14.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "flat_coated_retriever",
    "label_en": "Flat-coated Retriever",
    "label_nl": "Flatcoated retriever",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "florida_cracker_cur",
    "label_en": "Florida Brown Dog a/k/a Florida Cracker Cur",
    "label_nl": "Florida brown dog",
    "avg_weight_male": 25.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "french_bulldog",
    "label_en": "French Bulldog",
    "label_nl": "Franse bulldog",
    "avg_weight_male": 13.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "french_spaniel",
    "label_en": "French Spaniel",
    "label_nl": "Franse spaniël",
    "avg_weight_male": 28.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "frenchton",
    "label_en": "Frenchton",
    "label_nl": "Frenchton",
    "avg_weight_male": 11.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "galgo_espanol",
    "label_en": "Galgo Español",
    "label_nl": "Spaanse galgo",
    "avg_weight_male": 27.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "gascon_saintongeois",
    "label_en": "Gascon Saintongeois",
    "label_nl": "Gascon Saintongeois",
    "avg_weight_male": 35.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "gaucho_sheepdog",
    "label_en": "Gaucho sheepdog",
    "label_nl": "Gaucho sheepdog",
    "avg_weight_male": 30.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "georgian_shepherd",
    "label_en": "Georgian Shepherd",
    "label_nl": "Georgische herder",
    "avg_weight_male": 65.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "german_hound",
    "label_en": "German Hound",
    "label_nl": "Duitse brak",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "german_longhaired_pointer",
    "label_en": "German Longhaired Pointer",
    "label_nl": "Duitse langhaar",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "german_pinscher",
    "label_en": "German Pinscher",
    "label_nl": "Duitse pinscher",
    "avg_weight_male": 18.0,
    "avg_weight_female": 13.0
  },
  {
    "value": "german_roughhaired_pointer",
    "label_en": "German Roughhaired Pointer",
    "label_nl": "Duitse ruwharige staande hond",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "german_shepherd",
    "label_en": "German Shepherd",
    "label_nl": "Duitse herder",
    "avg_weight_male": 36.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "german_shorthaired_pointer",
    "label_en": "German Shorthaired Pointer",
    "label_nl": "Duitse korthaar",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "german_spaniel",
    "label_en": "German Spaniel",
    "label_nl": "Duitse wachtelhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "german_spitz",
    "label_en": "German Spitz",
    "label_nl": "Duitse spits",
    "avg_weight_male": 15.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "german_wirehaired_pointer",
    "label_en": "German Wirehaired Pointer",
    "label_nl": "Duitse draadhaar",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "giant_schnauzer",
    "label_en": "Giant Schnauzer",
    "label_nl": "Riesenschnauzer",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "glen_of_imaal_terrier",
    "label_en": "Glen of Imaal Terrier",
    "label_nl": "Glen of imaal terriër",
    "avg_weight_male": 18.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "goldador",
    "label_en": "Goldador",
    "label_nl": "Goldador",
    "avg_weight_male": 34.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "golden_retriever",
    "label_en": "Golden Retriever",
    "label_nl": "Golden retriever",
    "avg_weight_male": 34.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "goldendoodle",
    "label_en": "Goldendoodle",
    "label_nl": "Goldendoodle",
    "avg_weight_male": 30.0,
    "avg_weight_female": 26.0
  },
  {
    "value": "gordon_setter",
    "label_en": "Gordon Setter",
    "label_nl": "Gordon setter",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "gonczy_polski",
    "label_en": "Gończy Polski",
    "label_nl": "Poolse jachthond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "grand_anglo_francais_blanc_et_noir",
    "label_en": "Grand Anglo-Français Blanc et Noir",
    "label_nl": "Grand Anglo-Français Blanc et Noir",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "grand_anglo_francais_blanc_et_orange",
    "label_en": "Grand Anglo-Français Blanc et Orange",
    "label_nl": "Grand Anglo-Français Blanc et Orange",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "grand_anglo_francais_tricolore",
    "label_en": "Grand Anglo-Français Tricolore",
    "label_nl": "Grand Anglo-Français Tricolore",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "grand_basset_griffon_vendeen",
    "label_en": "Grand Basset Griffon Vendéen",
    "label_nl": "Grand basset griffon vendéen",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "grand_bleu_de_gascogne",
    "label_en": "Grand Bleu de Gascogne",
    "label_nl": "Grand Bleu de Gascogne",
    "avg_weight_male": 36.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "grand_griffon_vendeen",
    "label_en": "Grand Griffon Vendéen",
    "label_nl": "Grand griffon vendéen",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "great_dane",
    "label_en": "Great Dane",
    "label_nl": "Duitse dog",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "greater_swiss_mountain_dog",
    "label_en": "Greater Swiss Mountain Dog",
    "label_nl": "Grote Zwitserse sennenhond",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "greek_harehound",
    "label_en": "Greek Harehound",
    "label_nl": "Griekse hazenjager",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "greek_shepherd",
    "label_en": "Greek Shepherd",
    "label_nl": "Griekse herder",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "greenland_dog",
    "label_en": "Greenland Dog",
    "label_nl": "Groenlandse hond",
    "avg_weight_male": 36.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "greyhound",
    "label_en": "Greyhound",
    "label_nl": "Greyhound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "griffon_bleu_de_gascogne",
    "label_en": "Griffon Bleu de Gascogne",
    "label_nl": "Griffon Bleu de Gascogne",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "griffon_bruxellois",
    "label_en": "Griffon Bruxellois",
    "label_nl": "Brusselse griffon",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "griffon_fauve_de_bretagne",
    "label_en": "Griffon Fauve de Bretagne",
    "label_nl": "Griffon Fauve de Bretagne",
    "avg_weight_male": 25.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "griffon_nivernais",
    "label_en": "Griffon Nivernais",
    "label_nl": "Griffon Nivernais",
    "avg_weight_male": 28.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "gull_dong",
    "label_en": "Gull Dong",
    "label_nl": "Gull Dong",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "gull_terrier",
    "label_en": "Gull Terrier",
    "label_nl": "Gull terriër",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "halden_hound",
    "label_en": "Halden Hound",
    "label_nl": "Halden brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "hamiltonstovare",
    "label_en": "Hamiltonstövare",
    "label_nl": "Hamiltonstövare",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "hanover_hound",
    "label_en": "Hanover Hound",
    "label_nl": "Hannoveraanse zweethond",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "harrier",
    "label_en": "Harrier",
    "label_nl": "Harrier",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "havanese",
    "label_en": "Havanese",
    "label_nl": "Havanezer",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "havapoo",
    "label_en": "Havapoo",
    "label_nl": "Havapoo",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "himalayan_sheepdog",
    "label_en": "Himalayan Sheepdog",
    "label_nl": "Himalaya herdershond",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "hmong_bobtail_dog",
    "label_en": "Hmong bobtail dog",
    "label_nl": "Hmong bobtail dog",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "hokkaido",
    "label_en": "Hokkaido",
    "label_nl": "Hokkaido",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "hovawart",
    "label_en": "Hovawart",
    "label_nl": "Hovawart",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "huntaway",
    "label_en": "Huntaway",
    "label_nl": "Huntaway",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "huskador",
    "label_en": "Huskador",
    "label_nl": "Huskador",
    "avg_weight_male": 30.0,
    "avg_weight_female": 26.0
  },
  {
    "value": "hygen_hound",
    "label_en": "Hygen Hound",
    "label_nl": "Hygen brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "hallefors_elkhound",
    "label_en": "Hällefors Elkhound",
    "label_nl": "Hällefors elandhond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "ibizan_hound",
    "label_en": "Ibizan Hound",
    "label_nl": "Podenco ibicenco",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "icelandic_sheepdog",
    "label_en": "Icelandic Sheepdog",
    "label_nl": "IJslandse herdershond",
    "avg_weight_male": 14.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "indian_pariah_dog",
    "label_en": "Indian pariah dog",
    "label_nl": "Indiase pariahhond",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "indian_spitz",
    "label_en": "Indian Spitz",
    "label_nl": "Indiase spits",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "irish_red_and_white_setter",
    "label_en": "Irish Red and White Setter",
    "label_nl": "Ierse rood witte setter",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "irish_setter",
    "label_en": "Irish Setter",
    "label_nl": "Ierse setter",
    "avg_weight_male": 34.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "irish_terrier",
    "label_en": "Irish Terrier",
    "label_nl": "Ierse terriër",
    "avg_weight_male": 14.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "irish_water_spaniel",
    "label_en": "Irish Water Spaniel",
    "label_nl": "Ierse waterspaniël",
    "avg_weight_male": 30.0,
    "avg_weight_female": 24.0
  },
  {
    "value": "irish_wolfhound",
    "label_en": "Irish Wolfhound",
    "label_nl": "Ierse wolfshond",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "istrian_coarse_haired_hound",
    "label_en": "Istrian Coarse-haired Hound",
    "label_nl": "Istrische ruwharige brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "istrian_shorthaired_hound",
    "label_en": "Istrian Shorthaired Hound",
    "label_nl": "Istrische kortharige brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "italian_greyhound",
    "label_en": "Italian Greyhound",
    "label_nl": "Italiaanse windhond",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "jack_russell_terrier",
    "label_en": "Jack Russell Terrier",
    "label_nl": "Jack russell terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "jackapoo",
    "label_en": "Jackapoo",
    "label_nl": "Jackapoo",
    "avg_weight_male": 9.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "jagdterrier",
    "label_en": "Jagdterrier",
    "label_nl": "Duitse jachtterriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "japanese_chin",
    "label_en": "Japanese Chin",
    "label_nl": "Japanse spaniël",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "japanese_spitz",
    "label_en": "Japanese Spitz",
    "label_nl": "Japanse spits",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "japanese_terrier",
    "label_en": "Japanese Terrier",
    "label_nl": "Japanse terriër",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "jeju",
    "label_en": "Jeju",
    "label_nl": "Jeju hond",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "jindo",
    "label_en": "Jindo",
    "label_nl": "Jindo",
    "avg_weight_male": 23.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "jonangi",
    "label_en": "Jonangi",
    "label_nl": "Jonangi",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "jug",
    "label_en": "Jug",
    "label_nl": "Jug",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "jamthund",
    "label_en": "Jämthund",
    "label_nl": "Zweedse elandhond",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "kai_ken",
    "label_en": "Kai Ken",
    "label_nl": "Kai Ken",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "kaikadi",
    "label_en": "Kaikadi",
    "label_nl": "Kaikadi",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "kamchatka_sled_dog",
    "label_en": "Kamchatka Sled Dog",
    "label_nl": "Kamtsjatka sledehond",
    "avg_weight_male": 35.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "kangal_shepherd_dog",
    "label_en": "Kangal Shepherd Dog",
    "label_nl": "Kangal herdershond",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "kanni",
    "label_en": "Kanni",
    "label_nl": "Kanni",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "karakachan",
    "label_en": "Karakachan",
    "label_nl": "Karakachan",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "karelian_bear_dog",
    "label_en": "Karelian Bear Dog",
    "label_nl": "Karelische berenhond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "karelo_finnish_laika",
    "label_en": "Karelo-Finnish Laika",
    "label_nl": "Karelo-Finse laika",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "kars",
    "label_en": "Kars",
    "label_nl": "Kars",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "karst_shepherd",
    "label_en": "Karst Shepherd",
    "label_nl": "Karst herdershond",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "kazakh_tazy",
    "label_en": "Kazakh Tazy",
    "label_nl": "Kazakh Tazy",
    "avg_weight_male": 28.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "keeshond",
    "label_en": "Keeshond",
    "label_nl": "Keeshond",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "kerry_beagle",
    "label_en": "Kerry Beagle",
    "label_nl": "Kerry beagle",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "kerry_blue_terrier",
    "label_en": "Kerry Blue Terrier",
    "label_nl": "Kerry blue terriër",
    "avg_weight_male": 17.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "khala",
    "label_en": "Khala",
    "label_nl": "Khala",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "king_charles_spaniel",
    "label_en": "King Charles Spaniel",
    "label_nl": "King charles spaniël",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "king_shepherd",
    "label_en": "King Shepherd",
    "label_nl": "King shepherd",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "kintamani",
    "label_en": "Kintamani",
    "label_nl": "Kintamani",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "kishu",
    "label_en": "Kishu",
    "label_nl": "Kishu",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "kokoni",
    "label_en": "Kokoni",
    "label_nl": "Kokoni",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "kombai",
    "label_en": "Kombai",
    "label_nl": "Kombai",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "komondor",
    "label_en": "Komondor",
    "label_nl": "Komondor",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "kooikerhondje",
    "label_en": "Kooikerhondje",
    "label_nl": "Kooikerhondje",
    "avg_weight_male": 13.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "koolie",
    "label_en": "Koolie",
    "label_nl": "Koolie",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "kromfohrlander",
    "label_en": "Kromfohrländer",
    "label_nl": "Kromfohrländer",
    "avg_weight_male": 14.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "kuchi",
    "label_en": "Kuchi",
    "label_nl": "Kuchi",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "kunma",
    "label_en": "Kunma",
    "label_nl": "Kunma",
    "avg_weight_male": 35.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "kunming",
    "label_en": "Kunming",
    "label_nl": "Kunming",
    "avg_weight_male": 38.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "kurdish_mastiff",
    "label_en": "Kurdish Mastiff",
    "label_nl": "Koerdische mastiff",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "kuvasz",
    "label_en": "Kuvasz",
    "label_nl": "Kuvasz",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "labrabull",
    "label_en": "Labrabull",
    "label_nl": "Labrabull",
    "avg_weight_male": 34.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "labradoodle",
    "label_en": "Labradoodle",
    "label_nl": "Labradoodle",
    "avg_weight_male": 28.0,
    "avg_weight_female": 24.0
  },
  {
    "value": "labrador_retriever",
    "label_en": "Labrador Retriever",
    "label_nl": "Labrador retriever",
    "avg_weight_male": 36.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "labrakita",
    "label_en": "Labrakita",
    "label_nl": "Labrakita",
    "avg_weight_male": 34.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "lagotto_romagnolo",
    "label_en": "Lagotto Romagnolo",
    "label_nl": "Lagotto Romagnolo",
    "avg_weight_male": 16.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "laizhou_hong",
    "label_en": "Laizhou Hong",
    "label_nl": "Laizhou Hong",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "lakeland_terrier",
    "label_en": "Lakeland Terrier",
    "label_nl": "Lakeland terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "lancashire_heeler",
    "label_en": "Lancashire Heeler",
    "label_nl": "Lancashire Heeler",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "landseer",
    "label_en": "Landseer",
    "label_nl": "Landseer",
    "avg_weight_male": 60.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "langqing",
    "label_en": "Langqing",
    "label_nl": "Langqing",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "lapponian_herder",
    "label_en": "Lapponian Herder",
    "label_nl": "Laplandse herder",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "large_munsterlander",
    "label_en": "Large Münsterländer",
    "label_nl": "Grote münsterlander",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "leonberger",
    "label_en": "Leonberger",
    "label_nl": "Leonberger",
    "avg_weight_male": 70.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "levriero_sardo",
    "label_en": "Levriero Sardo",
    "label_nl": "Levriero Sardo",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "lhasa_apso",
    "label_en": "Lhasa Apso",
    "label_nl": "Lhasa Apso",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "liangshan_dog",
    "label_en": "Liangshan Dog",
    "label_nl": "Liangshan hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "lithuanian_hound",
    "label_en": "Lithuanian Hound",
    "label_nl": "Litouwse hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "lobito_herreno",
    "label_en": "Lobito Herreño",
    "label_nl": "Lobito Herreño",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "lucas_terrier",
    "label_en": "Lucas Terrier",
    "label_nl": "Lucas terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "lupo_italiano",
    "label_en": "Lupo Italiano",
    "label_nl": "Lupo Italiano",
    "avg_weight_male": 35.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "lai",
    "label_en": "Lài",
    "label_nl": "Lài",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "lowchen",
    "label_en": "Löwchen",
    "label_nl": "Löwchen",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "mackenzie_river_husky",
    "label_en": "Mackenzie River Husky",
    "label_nl": "Mackenzie river husky",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "magyar_agar",
    "label_en": "Magyar Agár",
    "label_nl": "Magyar Agár",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "mahratta_hound",
    "label_en": "Mahratta Hound",
    "label_nl": "Mahratta hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "majorca_shepherd_dog",
    "label_en": "Majorca Shepherd Dog",
    "label_nl": "Majorca herdershond",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "maltese",
    "label_en": "Maltese",
    "label_nl": "Maltezer",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "maltipoo",
    "label_en": "Maltipoo",
    "label_nl": "Maltipoo",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "manchester_terrier",
    "label_en": "Manchester Terrier",
    "label_nl": "Manchester terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "maneto",
    "label_en": "Maneto",
    "label_nl": "Maneto",
    "avg_weight_male": 9.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "maremmano_abruzzese_sheepdog",
    "label_en": "Maremmano-Abruzzese Sheepdog",
    "label_nl": "Maremma Abruzzen herdershond",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "markiesje",
    "label_en": "Markiesje",
    "label_nl": "Markiesje",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "mcnab",
    "label_en": "McNab",
    "label_nl": "McNab",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "miniature_american_shepherd",
    "label_en": "Miniature American Shepherd",
    "label_nl": "Miniature American shepherd",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "miniature_bull_terrier",
    "label_en": "Miniature Bull Terrier",
    "label_nl": "Miniature bull terriër",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "miniature_fox_terrier",
    "label_en": "Miniature Fox Terrier",
    "label_nl": "Miniature fox terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "miniature_pinscher",
    "label_en": "Miniature Pinscher",
    "label_nl": "Dwergpinscher",
    "avg_weight_male": 6.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "miniature_schnauzer",
    "label_en": "Miniature Schnauzer",
    "label_nl": "Dwergschnauzer",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "mojee",
    "label_en": "Mojee",
    "label_nl": "Mojee",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "molossus_of_epirus",
    "label_en": "Molossus of Epirus",
    "label_nl": "Molossus of Epirus",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "mongrel",
    "label_en": "Mongrel",
    "label_nl": "Kruising",
    "avg_weight_male": 18.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "montenegrin_mountain_hound",
    "label_en": "Montenegrin Mountain Hound",
    "label_nl": "Montenegrijnse berghond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "moscow_watchdog",
    "label_en": "Moscow Watchdog",
    "label_nl": "Moskouse waakhond",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "mountain_cur",
    "label_en": "Mountain Cur",
    "label_nl": "Mountain Cur",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "mountain_feist",
    "label_en": "Mountain Feist",
    "label_nl": "Mountain Feist",
    "avg_weight_male": 12.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "mudhol_hound",
    "label_en": "Mudhol Hound",
    "label_nl": "Mudhol hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "mudi",
    "label_en": "Mudi",
    "label_nl": "Mudi",
    "avg_weight_male": 13.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "neapolitan_mastiff",
    "label_en": "Neapolitan Mastiff",
    "label_nl": "Napolitaanse mastiff",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "nenets_herding_laika",
    "label_en": "Nenets Herding Laika",
    "label_nl": "Nenets herderslaika",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "new_guinea_singing_dog",
    "label_en": "New Guinea singing dog",
    "label_nl": "Nieuw Guinea zingende hond",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "new_zealand_heading_dog",
    "label_en": "New Zealand Heading Dog",
    "label_nl": "Nieuw Zeelandse heading dog",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "newfoundland",
    "label_en": "Newfoundland",
    "label_nl": "Newfoundlander",
    "avg_weight_male": 70.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "newfypoo",
    "label_en": "Newfypoo",
    "label_nl": "Newfypoo",
    "avg_weight_male": 44.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "norfolk_terrier",
    "label_en": "Norfolk Terrier",
    "label_nl": "Norfolk terriër",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "norrbottenspets",
    "label_en": "Norrbottenspets",
    "label_nl": "Norrbottenspets",
    "avg_weight_male": 14.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "northern_inuit_dog",
    "label_en": "Northern Inuit Dog",
    "label_nl": "Northern inuit dog",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "norwegian_buhund",
    "label_en": "Norwegian Buhund",
    "label_nl": "Noorse buhund",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "norwegian_elkhound",
    "label_en": "Norwegian Elkhound",
    "label_nl": "Noorse elandhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "norwegian_lundehund",
    "label_en": "Norwegian Lundehund",
    "label_nl": "Noorse lundehond",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "norwich_terrier",
    "label_en": "Norwich Terrier",
    "label_nl": "Norwich terriër",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "nova_scotia_duck_tolling_retriever",
    "label_en": "Nova Scotia Duck Tolling Retriever",
    "label_nl": "Nova scotia duck tolling retriever",
    "avg_weight_male": 23.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "nureongi",
    "label_en": "Nureongi",
    "label_nl": "Nureongi",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "old_danish_pointer",
    "label_en": "Old Danish Pointer",
    "label_nl": "Oude Deense staande hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "old_english_sheepdog",
    "label_en": "Old English Sheepdog",
    "label_nl": "Old English sheepdog",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "olde_english_bulldogge",
    "label_en": "Olde English Bulldogge",
    "label_nl": "Olde English bulldogge",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "otterhound",
    "label_en": "Otterhound",
    "label_nl": "Otterhound",
    "avg_weight_male": 52.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "pachon_navarro",
    "label_en": "Pachón Navarro",
    "label_nl": "Pachón Navarro",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "pampas_deerhound",
    "label_en": "Pampas Deerhound",
    "label_nl": "Pampas Deerhound",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "papillon",
    "label_en": "Papillon",
    "label_nl": "Papillon",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "parson_russell_terrier",
    "label_en": "Parson Russell Terrier",
    "label_nl": "Parson russell terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "pastor_garafiano",
    "label_en": "Pastor Garafiano",
    "label_nl": "Pastor Garafiano",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "pastore_della_lessinia_e_del_lagorai",
    "label_en": "Pastore della Lessinia e del Lagorai",
    "label_nl": "Pastore della Lessinia e del Lagorai",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "patagonian_sheepdog",
    "label_en": "Patagonian Sheepdog",
    "label_nl": "Patagonian Sheepdog",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "patterdale_terrier",
    "label_en": "Patterdale Terrier",
    "label_nl": "Patterdale terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "peekapoo",
    "label_en": "Peekapoo",
    "label_nl": "Peekapoo",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "pekingese",
    "label_en": "Pekingese",
    "label_nl": "Pekinees",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "pembroke_welsh_corgi",
    "label_en": "Pembroke Welsh Corgi",
    "label_nl": "Welsh corgi pembroke",
    "avg_weight_male": 13.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "perdigueiro_galego",
    "label_en": "Perdigueiro Galego",
    "label_nl": "Perdigueiro Galego",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "perro_majorero",
    "label_en": "Perro Majorero",
    "label_nl": "Perro Majorero",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "peruvian_hairless_dog",
    "label_en": "Peruvian Hairless Dog",
    "label_nl": "Peruaanse naakthond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "petit_basset_griffon_vendeen",
    "label_en": "Petit Basset Griffon Vendéen",
    "label_nl": "Petit basset griffon vendéen",
    "avg_weight_male": 18.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "petit_bleu_de_gascogne",
    "label_en": "Petit Bleu de Gascogne",
    "label_nl": "Petit Bleu de Gascogne",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "phalene",
    "label_en": "Phalène",
    "label_nl": "Phalène",
    "avg_weight_male": 5.0,
    "avg_weight_female": 4.0
  },
  {
    "value": "pharaoh_hound",
    "label_en": "Pharaoh Hound",
    "label_nl": "Pharaoh hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "philippine_forest_dog",
    "label_en": "Philippine forest dog",
    "label_nl": "Filipijnse bos hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "phu_quoc_ridgeback",
    "label_en": "Phu Quoc Ridgeback",
    "label_nl": "Phu quoc ridgeback",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "picardy_spaniel",
    "label_en": "Picardy Spaniel",
    "label_nl": "Picardische spaniël",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "pitsky",
    "label_en": "Pitsky",
    "label_nl": "Pitsky",
    "avg_weight_male": 28.0,
    "avg_weight_female": 24.0
  },
  {
    "value": "plott_hound",
    "label_en": "Plott Hound",
    "label_nl": "Plott hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "plummer_terrier",
    "label_en": "Plummer Terrier",
    "label_nl": "Plummer terriër",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "podenco_andaluz",
    "label_en": "Podenco Andaluz",
    "label_nl": "Podenco Andaluz",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "podenco_canario",
    "label_en": "Podenco Canario",
    "label_nl": "Podenco Canario",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "podenco_valenciano",
    "label_en": "Podenco Valenciano",
    "label_nl": "Podenco Valenciano",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "pointer",
    "label_en": "Pointer",
    "label_nl": "Pointer",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "poitevin",
    "label_en": "Poitevin",
    "label_nl": "Poitevin",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "polish_greyhound",
    "label_en": "Polish Greyhound",
    "label_nl": "Poolse windhond",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "polish_hound",
    "label_en": "Polish Hound",
    "label_nl": "Poolse hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "polish_lowland_sheepdog",
    "label_en": "Polish Lowland Sheepdog",
    "label_nl": "Poolse laaglandherder",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "pomchi",
    "label_en": "Pomchi",
    "label_nl": "Pomchi",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "pomeranian",
    "label_en": "Pomeranian",
    "label_nl": "Pomeriaan",
    "avg_weight_male": 3.0,
    "avg_weight_female": 2.0
  },
  {
    "value": "pomeranian_chihuahua_mix",
    "label_en": "Pomeranian Chihuahua Mix",
    "label_nl": "Pomeriaan Chihuahua mix",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "pomsky",
    "label_en": "Pomsky",
    "label_nl": "Pomsky",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "pont_audemer_spaniel",
    "label_en": "Pont-Audemer Spaniel",
    "label_nl": "Pont Audemer spaniël",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "poodle",
    "label_en": "Poodle",
    "label_nl": "Poedel",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "porcelaine",
    "label_en": "Porcelaine",
    "label_nl": "Porcelaine",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "portuguese_podengo",
    "label_en": "Portuguese Podengo",
    "label_nl": "Portugese podengo",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "portuguese_pointer",
    "label_en": "Portuguese Pointer",
    "label_nl": "Portugese pointer",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "portuguese_sheepdog",
    "label_en": "Portuguese Sheepdog",
    "label_nl": "Portugese herdershond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "portuguese_water_dog",
    "label_en": "Portuguese Water Dog",
    "label_nl": "Portugese waterhond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "posavac_hound",
    "label_en": "Posavac Hound",
    "label_nl": "Posavac hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "prazsky_krysarik",
    "label_en": "Pražský Krysařík",
    "label_nl": "Praagse rattenterrier",
    "avg_weight_male": 3.0,
    "avg_weight_female": 2.0
  },
  {
    "value": "presa_canario",
    "label_en": "Presa Canario",
    "label_nl": "Presa canario",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "pudelpointer",
    "label_en": "Pudelpointer",
    "label_nl": "Pudelpointer",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "pug",
    "label_en": "Pug",
    "label_nl": "Pug",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "puggle",
    "label_en": "Puggle",
    "label_nl": "Puggle",
    "avg_weight_male": 11.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "puli",
    "label_en": "Puli",
    "label_nl": "Puli",
    "avg_weight_male": 16.0,
    "avg_weight_female": 13.0
  },
  {
    "value": "pumi",
    "label_en": "Pumi",
    "label_nl": "Pumi",
    "avg_weight_male": 13.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "pungsan",
    "label_en": "Pungsan",
    "label_nl": "Pungsan",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "pyredoodle",
    "label_en": "Pyredoodle",
    "label_nl": "Pyredoodle",
    "avg_weight_male": 42.0,
    "avg_weight_female": 38.0
  },
  {
    "value": "pyrenean_mastiff",
    "label_en": "Pyrenean Mastiff",
    "label_nl": "Pyrenese mastiff",
    "avg_weight_male": 70.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "pyrenean_mountain_dog",
    "label_en": "Pyrenean Mountain Dog",
    "label_nl": "Pyrenese berghond",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "pyrenean_sheepdog",
    "label_en": "Pyrenean Sheepdog",
    "label_nl": "Pyrenean Sheepdog",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "rafeiro_do_alentejo",
    "label_en": "Rafeiro do Alentejo",
    "label_nl": "Rafeiro do Alentejo",
    "avg_weight_male": 50.0,
    "avg_weight_female": 40.0
  },
  {
    "value": "rajapalayam",
    "label_en": "Rajapalayam",
    "label_nl": "Rajapalayam",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "rampur_greyhound",
    "label_en": "Rampur Greyhound",
    "label_nl": "Rampur Greyhound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "rastreador_brasileiro",
    "label_en": "Rastreador Brasileiro",
    "label_nl": "Rastreador Brasileiro",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "rat_terrier",
    "label_en": "Rat Terrier",
    "label_nl": "Rat terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "ratonero_murciano",
    "label_en": "Ratonero Murciano",
    "label_nl": "Ratonero Murciano",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "redbone_coonhound",
    "label_en": "Redbone Coonhound",
    "label_nl": "Redbone Coonhound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "rhodesian_ridgeback",
    "label_en": "Rhodesian Ridgeback",
    "label_nl": "Rhodesian ridgeback",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "rize_koyun",
    "label_en": "Rize Koyun",
    "label_nl": "Rize Koyun",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "romanian_mioritic_shepherd_dog",
    "label_en": "Romanian Mioritic Shepherd Dog",
    "label_nl": "Roemeense mioritic herder",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "romanian_raven_shepherd_dog",
    "label_en": "Romanian Raven Shepherd Dog",
    "label_nl": "Roemeense raven herder",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "rottador",
    "label_en": "Rottador",
    "label_nl": "Rottador",
    "avg_weight_male": 40.0,
    "avg_weight_female": 36.0
  },
  {
    "value": "rottweiler",
    "label_en": "Rottweiler",
    "label_nl": "Rottweiler",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "rough_collie",
    "label_en": "Rough Collie",
    "label_nl": "Schotse herder langhaar",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "russian_spaniel",
    "label_en": "Russian Spaniel",
    "label_nl": "Russische spaniël",
    "avg_weight_male": 18.0,
    "avg_weight_female": 14.0
  },
  {
    "value": "russkiy_toy",
    "label_en": "Russkiy Toy",
    "label_nl": "Russische toy",
    "avg_weight_male": 3.0,
    "avg_weight_female": 2.0
  },
  {
    "value": "russo_european_laika",
    "label_en": "Russo-European Laika",
    "label_nl": "Russisch Europese laika",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "ryukyu",
    "label_en": "Ryukyu",
    "label_nl": "Ryukyu",
    "avg_weight_male": 20.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "saarloos_wolfdog",
    "label_en": "Saarloos Wolfdog",
    "label_nl": "Saarlooswolfhond",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "sabueso_espanol",
    "label_en": "Sabueso Español",
    "label_nl": "Spaanse brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "saint_miguel_cattle_dog",
    "label_en": "Saint Miguel Cattle Dog",
    "label_nl": "São Miguel veedrijvershond",
    "avg_weight_male": 35.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "saint_usuge_spaniel",
    "label_en": "Saint-Usuge Spaniel",
    "label_nl": "Saint Usuge spaniël",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "sakhalin_husky",
    "label_en": "Sakhalin Husky",
    "label_nl": "Sachalin husky",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "saluki",
    "label_en": "Saluki",
    "label_nl": "Saluki",
    "avg_weight_male": 28.0,
    "avg_weight_female": 22.0
  },
  {
    "value": "samoyed",
    "label_en": "Samoyed",
    "label_nl": "Samojeed",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "sapsali",
    "label_en": "Sapsali",
    "label_nl": "Sapsali",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "sarabi",
    "label_en": "Sarabi",
    "label_nl": "Sarabi",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "sarail_hound",
    "label_en": "Sarail Hound",
    "label_nl": "Sarail hound",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "sardinian_shepherd_dog",
    "label_en": "Sardinian Shepherd Dog",
    "label_nl": "Sardijnse herdershond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "schapendoes",
    "label_en": "Schapendoes",
    "label_nl": "Schapendoes",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "schillerstovare",
    "label_en": "Schillerstövare",
    "label_nl": "Schiller brak",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "schipperke",
    "label_en": "Schipperke",
    "label_nl": "Schipperke",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "schnoodle",
    "label_en": "Schnoodle",
    "label_nl": "Schnoodle",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "schweizer_laufhund",
    "label_en": "Schweizer Laufhund",
    "label_nl": "Zwitserse lopende hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "schweizerischer_niederlaufhund",
    "label_en": "Schweizerischer Niederlaufhund",
    "label_nl": "Zwitserse kleine lopende hond",
    "avg_weight_male": 18.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "scottish_deerhound",
    "label_en": "Scottish Deerhound",
    "label_nl": "Schotse deerhound",
    "avg_weight_male": 45.0,
    "avg_weight_female": 36.0
  },
  {
    "value": "scottish_terrier",
    "label_en": "Scottish Terrier",
    "label_nl": "Schotse terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "sealyham_terrier",
    "label_en": "Sealyham Terrier",
    "label_nl": "Sealyham terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "segugio_dell_appennino",
    "label_en": "Segugio dell'Appennino",
    "label_nl": "Segugio dell'Appennino",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "segugio_italiano",
    "label_en": "Segugio Italiano",
    "label_nl": "Segugio Italiano",
    "avg_weight_male": 28.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "segugio_maremmano",
    "label_en": "Segugio Maremmano",
    "label_nl": "Segugio Maremmano",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "serbian_hound",
    "label_en": "Serbian Hound",
    "label_nl": "Servische hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "serbian_tricolour_hound",
    "label_en": "Serbian Tricolour Hound",
    "label_nl": "Servische driekleurige hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "serrano_bulldog",
    "label_en": "Serrano Bulldog",
    "label_nl": "Serrano bulldog",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "shar_pei",
    "label_en": "Shar Pei",
    "label_nl": "Shar Pei",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "sheepadoodle",
    "label_en": "Sheepadoodle",
    "label_nl": "Sheepadoodle",
    "avg_weight_male": 40.0,
    "avg_weight_female": 36.0
  },
  {
    "value": "shepsky",
    "label_en": "Shepsky",
    "label_nl": "Shepsky",
    "avg_weight_male": 32.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "shetland_sheepdog",
    "label_en": "Shetland Sheepdog",
    "label_nl": "Shetland sheepdog",
    "avg_weight_male": 10.0,
    "avg_weight_female": 8.0
  },
  {
    "value": "shiba_inu",
    "label_en": "Shiba Inu",
    "label_nl": "Shiba inu",
    "avg_weight_male": 11.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "shih_tzu",
    "label_en": "Shih Tzu",
    "label_nl": "Shih tzu",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "shihpoo",
    "label_en": "Shihpoo",
    "label_nl": "Shihpoo",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "shikoku",
    "label_en": "Shikoku",
    "label_nl": "Shikoku",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "shiloh_shepherd",
    "label_en": "Shiloh Shepherd",
    "label_nl": "Shiloh herder",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "siberian_husky",
    "label_en": "Siberian Husky",
    "label_nl": "Siberische husky",
    "avg_weight_male": 27.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "silken_windhound",
    "label_en": "Silken Windhound",
    "label_nl": "Silken Windhound",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "sinhala_hound",
    "label_en": "Sinhala Hound",
    "label_nl": "Sinhala hound",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "skye_terrier",
    "label_en": "Skye Terrier",
    "label_nl": "Skye Terrier",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "sloughi",
    "label_en": "Sloughi",
    "label_nl": "Sloughi",
    "avg_weight_male": 28.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "slovak_cuvac",
    "label_en": "Slovak Cuvac",
    "label_nl": "Slovak Cuvac",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "slovak_rough_haired_pointer",
    "label_en": "Slovak Rough-haired Pointer",
    "label_nl": "Slowaakse ruwharige staande hond",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "slovensky_kopov",
    "label_en": "Slovenský kopov",
    "label_nl": "Slovenský kopov",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "smaland_hound",
    "label_en": "Smaland Hound",
    "label_nl": "Småland brak",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "small_medimurje_dog",
    "label_en": "Small Međimurje Dog",
    "label_nl": "Small Međimurje Dog",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "small_munsterlander",
    "label_en": "Small Münsterländer",
    "label_nl": "Small Münsterländer",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "smithfield",
    "label_en": "Smithfield",
    "label_nl": "Smithfield",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "smooth_collie",
    "label_en": "Smooth Collie",
    "label_nl": "Schotse herder kortharig",
    "avg_weight_male": 28.0,
    "avg_weight_female": 23.0
  },
  {
    "value": "smooth_fox_terrier",
    "label_en": "Smooth Fox Terrier",
    "label_nl": "Gladharige fox terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "soft_coated_wheaten_terrier",
    "label_en": "Soft-coated Wheaten Terrier",
    "label_nl": "Ierse soft coated wheaten terriër",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "south_russian_ovcharka",
    "label_en": "South Russian Ovcharka",
    "label_nl": "Zuid Russische ovcharka",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "spanish_mastiff",
    "label_en": "Spanish Mastiff",
    "label_nl": "Spaanse mastiff",
    "avg_weight_male": 70.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "spanish_water_dog",
    "label_en": "Spanish Water Dog",
    "label_nl": "Spaanse waterhond",
    "avg_weight_male": 22.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "spino_degli_iblei",
    "label_en": "Spino degli Iblei",
    "label_nl": "Spino degli Iblei",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "spinone_italiano",
    "label_en": "Spinone Italiano",
    "label_nl": "Spinone italiano",
    "avg_weight_male": 37.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "sporting_lucas_terrier",
    "label_en": "Sporting Lucas Terrier",
    "label_nl": "Sporting Lucas Terrier",
    "avg_weight_male": 7.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "st_bernard",
    "label_en": "St. Bernard",
    "label_nl": "Sint Bernard",
    "avg_weight_male": 75.0,
    "avg_weight_female": 60.0
  },
  {
    "value": "st_hubert_jura_hound",
    "label_en": "St. Hubert Jura Hound",
    "label_nl": "Sint Hubertus hond",
    "avg_weight_male": 40.0,
    "avg_weight_female": 30.0
  },
  {
    "value": "stabyhoun",
    "label_en": "Stabyhoun",
    "label_nl": "Stabij",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "staffordshire_bull_terrier",
    "label_en": "Staffordshire Bull Terrier",
    "label_nl": "Staffordshire bull terriër",
    "avg_weight_male": 17.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "standard_schnauzer",
    "label_en": "Standard Schnauzer",
    "label_nl": "Middenschnauzer",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "stephens_stock",
    "label_en": "Stephens Stock",
    "label_nl": "Stephens Stock",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "styrian_coarse_haired_hound",
    "label_en": "Styrian Coarse-haired Hound",
    "label_nl": "Steirische ruwharige brak",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "sussex_spaniel",
    "label_en": "Sussex Spaniel",
    "label_nl": "Sussex spaniël",
    "avg_weight_male": 20.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "swedish_lapphund",
    "label_en": "Swedish Lapphund",
    "label_nl": "Zweedse lappenhond",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "swedish_vallhund",
    "label_en": "Swedish Vallhund",
    "label_nl": "Zweedse vallhund",
    "avg_weight_male": 14.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "taigan",
    "label_en": "Taigan",
    "label_nl": "Taigan",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "taiwan_dog",
    "label_en": "Taiwan Dog",
    "label_nl": "Taiwanese hond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "tamaskan_dog",
    "label_en": "Tamaskan Dog",
    "label_nl": "Tamaskan",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "tang_dog",
    "label_en": "Tang Dog",
    "label_nl": "Tang Dog",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "tarsus_catalburun",
    "label_en": "Tarsus çatalburun",
    "label_nl": "Tarsus çatalburun",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "tatra_shepherd_dog",
    "label_en": "Tatra Shepherd Dog",
    "label_nl": "Tatra Shepherd Dog",
    "avg_weight_male": 55.0,
    "avg_weight_female": 45.0
  },
  {
    "value": "teddy_roosevelt_terrier",
    "label_en": "Teddy Roosevelt Terrier",
    "label_nl": "Teddy Roosevelt terriër",
    "avg_weight_male": 12.0,
    "avg_weight_female": 10.0
  },
  {
    "value": "telomian",
    "label_en": "Telomian",
    "label_nl": "Telomian",
    "avg_weight_male": 15.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "tenterfield_terrier",
    "label_en": "Tenterfield Terrier",
    "label_nl": "Tenterfield Terrier",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "thai_bangkaew_dog",
    "label_en": "Thai Bangkaew Dog",
    "label_nl": "Thai bangkaew hond",
    "avg_weight_male": 23.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "thai_ridgeback",
    "label_en": "Thai Ridgeback",
    "label_nl": "Thai ridgeback",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "tibetan_kyi_apso",
    "label_en": "Tibetan Kyi Apso",
    "label_nl": "Tibetaanse kyi apso",
    "avg_weight_male": 20.0,
    "avg_weight_female": 16.0
  },
  {
    "value": "tibetan_mastiff",
    "label_en": "Tibetan Mastiff",
    "label_nl": "Tibetaanse mastiff",
    "avg_weight_male": 65.0,
    "avg_weight_female": 55.0
  },
  {
    "value": "tibetan_spaniel",
    "label_en": "Tibetan Spaniel",
    "label_nl": "Tibetaanse spaniël",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "tibetan_terrier",
    "label_en": "Tibetan Terrier",
    "label_nl": "Tibetaanse terriër",
    "avg_weight_male": 11.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "tonya_finosu",
    "label_en": "Tonya Finosu",
    "label_nl": "Tonya Finosu",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "tornjak",
    "label_en": "Tornjak",
    "label_nl": "Tornjak",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "tosa",
    "label_en": "Tosa",
    "label_nl": "Tosa",
    "avg_weight_male": 60.0,
    "avg_weight_female": 50.0
  },
  {
    "value": "toy_fox_terrier",
    "label_en": "Toy Fox Terrier",
    "label_nl": "Toy fox terriër",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "toy_manchester_terrier",
    "label_en": "Toy Manchester Terrier",
    "label_nl": "Toy Manchester terriër",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "transylvanian_hound",
    "label_en": "Transylvanian Hound",
    "label_nl": "Transsylvaanse hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "treeing_cur",
    "label_en": "Treeing Cur",
    "label_nl": "Treeing Cur",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "treeing_feist",
    "label_en": "Treeing Feist",
    "label_nl": "Treeing Feist",
    "avg_weight_male": 14.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "treeing_tennessee_brindle",
    "label_en": "Treeing Tennessee Brindle",
    "label_nl": "Treeing Tennessee Brindle",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "treeing_walker_coonhound",
    "label_en": "Treeing Walker Coonhound",
    "label_nl": "Treeing Walker Coonhound",
    "avg_weight_male": 32.0,
    "avg_weight_female": 27.0
  },
  {
    "value": "trigg_hound",
    "label_en": "Trigg Hound",
    "label_nl": "Trigg Hound",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "tyrolean_hound",
    "label_en": "Tyrolean Hound",
    "label_nl": "Tiroler brak",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "valdueza",
    "label_en": "Valdueza",
    "label_nl": "Valdueza",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "valencian_terrier",
    "label_en": "Valencian Terrier",
    "label_nl": "Valenciaanse terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 6.0
  },
  {
    "value": "vikhan",
    "label_en": "Vikhan",
    "label_nl": "Vikhan",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "villano_de_las_encartaciones",
    "label_en": "Villano de Las Encartaciones",
    "label_nl": "Villano de Las Encartaciones",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  },
  {
    "value": "villanuco_de_las_encartaciones",
    "label_en": "Villanuco de Las Encartaciones",
    "label_nl": "Villanuco de Las Encartaciones",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "vizsla",
    "label_en": "Vizsla",
    "label_nl": "Vizsla",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "volkosob",
    "label_en": "Volkosob",
    "label_nl": "Volkosob",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "volpino_italiano",
    "label_en": "Volpino Italiano",
    "label_nl": "Volpino Italiano",
    "avg_weight_male": 6.0,
    "avg_weight_female": 5.0
  },
  {
    "value": "weimaraner",
    "label_en": "Weimaraner",
    "label_nl": "Weimaraner",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "welsh_hound",
    "label_en": "Welsh Hound",
    "label_nl": "Welshe hond",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "welsh_sheepdog",
    "label_en": "Welsh Sheepdog",
    "label_nl": "Welshe herdershond",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "welsh_springer_spaniel",
    "label_en": "Welsh Springer Spaniel",
    "label_nl": "Welsh springer spaniël",
    "avg_weight_male": 23.0,
    "avg_weight_female": 18.0
  },
  {
    "value": "welsh_terrier",
    "label_en": "Welsh Terrier",
    "label_nl": "Welsh terriër",
    "avg_weight_male": 10.0,
    "avg_weight_female": 9.0
  },
  {
    "value": "west_country_harrier",
    "label_en": "West Country Harrier",
    "label_nl": "West Country Harrier",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "west_highland_white_terrier",
    "label_en": "West Highland White Terrier",
    "label_nl": "West highland white terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "west_siberian_laika",
    "label_en": "West Siberian Laika",
    "label_nl": "West Siberische laika",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "westphalian_dachsbracke",
    "label_en": "Westphalian Dachsbracke",
    "label_nl": "Westfaalse dachsbrak",
    "avg_weight_male": 18.0,
    "avg_weight_female": 15.0
  },
  {
    "value": "wetterhoun",
    "label_en": "Wetterhoun",
    "label_nl": "Wetterhoun",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "whippet",
    "label_en": "Whippet",
    "label_nl": "Whippet",
    "avg_weight_male": 14.0,
    "avg_weight_female": 12.0
  },
  {
    "value": "white_shepherd",
    "label_en": "White Shepherd",
    "label_nl": "Witte herder",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "white_swiss_shepherd_dog",
    "label_en": "White Swiss Shepherd Dog",
    "label_nl": "Witte Zwitserse herder",
    "avg_weight_male": 40.0,
    "avg_weight_female": 32.0
  },
  {
    "value": "whoodle",
    "label_en": "Whoodle",
    "label_nl": "Whoodle",
    "avg_weight_male": 22.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "wire_fox_terrier",
    "label_en": "Wire Fox Terrier",
    "label_nl": "Ruwharige fox terriër",
    "avg_weight_male": 8.0,
    "avg_weight_female": 7.0
  },
  {
    "value": "wirehaired_pointing_griffon",
    "label_en": "Wirehaired Pointing Griffon",
    "label_nl": "Draadharige griffon",
    "avg_weight_male": 32.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "wirehaired_vizsla",
    "label_en": "Wirehaired Vizsla",
    "label_nl": "Draadharige vizsla",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "xiasi_dog",
    "label_en": "Xiasi Dog",
    "label_nl": "Xiasi Dog",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "xigou",
    "label_en": "Xigou",
    "label_nl": "Xigou",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "xoloitzcuintle",
    "label_en": "Xoloitzcuintle",
    "label_nl": "Xoloitzcuintle",
    "avg_weight_male": 14.0,
    "avg_weight_female": 11.0
  },
  {
    "value": "yakutian_laika",
    "label_en": "Yakutian Laika",
    "label_nl": "Jakoetse laika",
    "avg_weight_male": 25.0,
    "avg_weight_female": 20.0
  },
  {
    "value": "yorkipoo",
    "label_en": "Yorkipoo",
    "label_nl": "Yorkipoo",
    "avg_weight_male": 4.0,
    "avg_weight_female": 3.0
  },
  {
    "value": "yorkshire_terrier",
    "label_en": "Yorkshire Terrier",
    "label_nl": "Yorkshire terriër",
    "avg_weight_male": 3.0,
    "avg_weight_female": 2.0
  },
  {
    "value": "zerdava",
    "label_en": "Zerdava",
    "label_nl": "Zerdava",
    "avg_weight_male": 30.0,
    "avg_weight_female": 25.0
  },
  {
    "value": "cesky_fousek",
    "label_en": "Český fousek",
    "label_nl": "Český fousek",
    "avg_weight_male": 34.0,
    "avg_weight_female": 28.0
  },
  {
    "value": "sarplaninac",
    "label_en": "Šarplaninac",
    "label_nl": "Šarplaninac",
    "avg_weight_male": 45.0,
    "avg_weight_female": 35.0
  }
];

// Export for use in other files
window.Wizard1Breeds = BREEDS_DATA;
